module.exports = __webpack_public_path__ + "img/mandala-dna.9fe77bea.png";